import React, { useEffect } from 'react';
import { Button, Spinner, Alert, Modal } from 'react-bootstrap';
import * as api from '~/Services/Service';
import { useLocation, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import './EmpreendimentosContaBancaria.css';
import { FaRegCopy } from 'react-icons/fa';

const ContaBancariaContent = ({ familiaCodigo }) => {
  const [dados, setDados] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  const formatarCNPJ = cnpj => {
    if (!cnpj) return '';
    const cnpjLimpo = String(cnpj).toUpperCase().replace(/[^A-Z0-9]/g, '').padStart(14, '0');
    return cnpjLimpo.replace(
      /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})$/,
      '$1.$2.$3/$4-$5'
    );
  };

  var montarTextoCopia = function(conta) {
    if (!conta) return '';

    var texto =
      'Banco: ' +
      conta.codigo_banco +
      '-' +
      conta.banco +
      '\r\n' +
      'Agência: ' +
      conta.agencia +
      '\r\n' +
      'Conta: ' +
      conta.conta +
      '\r\n' +
      'CNPJ: ' +
      formatarCNPJ(conta.cnpj) +
      '\r\n' +
      'Razão: ' +
      conta.razao_social;

    if (conta.pix_tipo && conta.pix_chave && conta.pix_chave.trim()) {
      texto +=
        '\r\nChave PIX: ' + conta.pix_tipo + ' - ' + conta.pix_chave.trim();
    }

    return texto;
  };

  var copiarParaClipboard = async function(conta, tipo) {
    var texto = montarTextoCopia(conta);
    try {
      var textArea = document.createElement('textarea');
      textArea.value = texto;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        var successful = document.execCommand('copy');
        document.body.removeChild(textArea);
        if (successful) {
          toast.success(
            'Dados ' +
              (tipo === 'empreendimento'
                ? 'do empreendimento'
                : 'da imobiliária') +
              ' copiados!'
          );
        } else {
          throw new Error('Comando de cópia falhou');
        }
      } catch (err) {
        document.body.removeChild(textArea);
        throw err;
      }
    } catch (err) {
      console.error('Erro ao copiar:', err);
      toast.error('Erro ao copiar dados para área de transferência');
    }
  };

  var temDadosPix = function(conta) {
    return conta && conta.pix_tipo && conta.pix_chave && conta.pix_chave.trim();
  };

  useEffect(
    function() {
      var fetchData = async function() {
        setLoading(true);
        setError(null);
        setDados(null);

        try {
          var data = await api.dadosBancariosEmpreendimento(familiaCodigo);
          setDados(data);
        } catch (err) {
          setError(
            err && err.message ? err.message : 'Erro ao buscar contas bancárias'
          );
        } finally {
          setLoading(false);
        }
      };
      if (familiaCodigo) {
        fetchData();
      }
    },
    [familiaCodigo]
  );

  var renderCard = function(conta, tipo) {
    if (!conta) return null;

    var isEmpreendimento = tipo === 'empreendimento';
    var titulo = isEmpreendimento ? 'Empreendimento' : 'Imobiliária';

    return (
      <div className="ContaBancaria__Card">
        <div className="ContaBancaria__CardHeader">
          <h3
            className={
              'ContaBancaria__CardTitle ContaBancaria__CardTitle--' + tipo
            }
          >
            {titulo}
          </h3>

          {!isEmpreendimento && conta.percentual_comissao > 0 && (
            <span className="ContaBancaria__CardBadge ContaBancaria__CardBadge--comissao">
              Sinal da imobiliária configurado em{' '}
              <strong>{conta.percentual_comissao}%</strong>
            </span>
          )}

          {isEmpreendimento && (
            <span className="ContaBancaria__CardBadge">
              Sinal urbanizadora*
            </span>
          )}
        </div>

        <div className="ContaBancaria__CardBody">
          <div className="ContaBancaria__InfoSection">
            <div className="ContaBancaria__InfoRow">
              <span className="ContaBancaria__InfoLabel">Banco:</span>
              <span className="ContaBancaria__InfoValue">{conta.banco}</span>
            </div>
            <div className="ContaBancaria__InfoRow">
              <span className="ContaBancaria__InfoLabel">Agência:</span>
              <span className="ContaBancaria__InfoValue">{conta.agencia}</span>
            </div>
            <div className="ContaBancaria__InfoRow">
              <span className="ContaBancaria__InfoLabel">Conta Corrente:</span>
              <span className="ContaBancaria__InfoValue">{conta.conta}</span>
            </div>
            <div className="ContaBancaria__InfoRow">
              <span className="ContaBancaria__InfoLabel">CNPJ Empresa:</span>
              <span className="ContaBancaria__InfoValue">
                {formatarCNPJ(conta.cnpj)}
              </span>
            </div>
            <div className="ContaBancaria__InfoRow">
              <span className="ContaBancaria__InfoLabel">Razão Social:</span>
              <span className="ContaBancaria__InfoValue">
                {conta.razao_social}
              </span>
            </div>
          </div>

          {temDadosPix(conta) && (
            <div className="ContaBancaria__PixSection">
              <div className="ContaBancaria__InfoRow">
                <span className="ContaBancaria__InfoLabel">Chave PIX:</span>
                <span className="ContaBancaria__InfoValue">
                  {conta.pix_tipo} - {conta.pix_chave.trim()}
                </span>
              </div>
            </div>
          )}
        </div>

        <div className="ContaBancaria__CardFooter">
          <Button
            variant="primary"
            className="ContaBancaria__BtnCopiar"
            onClick={function() {
              copiarParaClipboard(conta, tipo);
            }}
          >
            Copiar dados <FaRegCopy />
            <i className="fa fa-external-link" aria-hidden="true"></i>
          </Button>
        </div>
      </div>
    );
  };

  // Renderizar aviso de depósito
  var renderAviso = function() {
    return (
      <div className="ContaBancaria__Aviso">
        <p className="ContaBancaria__AvisoTitulo">
          *A conta para depósito de valores acima do Sinal Imobiliária
          configurado.
        </p>
        <p className="ContaBancaria__AvisoExemplo">
          Exemplo: V.V. R$ 100.000,00 e Sinal Imobiliária de 5% = R$ 5.000,00
        </p>
        <p className="ContaBancaria__AvisoTexto">
          O cliente paga R$ 9.000,00 de sinal, ou seja:
        </p>
        <p className="ContaBancaria__AvisoTexto">
          - R$ 5.000,00 será depósito para Imobiliária
        </p>
        <p className="ContaBancaria__AvisoTexto">
          - R$ 4.000,00 será depósito de{' '}
          <span className="ContaBancaria__AvisoDestaque">
            Sinal do empreendimento ou urbanizadora
          </span>
        </p>
      </div>
    );
  };

  // Verificar se existe pelo menos um card
  var temAlgumCard = dados && (dados.item1 || dados.item2);

  // Obter nome do empreendimento
  var nomeEmpreendimento = '';
  if (dados && dados.item1 && dados.item1.empreendimento) {
    nomeEmpreendimento = dados.item1.empreendimento;
  } else if (dados && dados.item2 && dados.item2.empreendimento) {
    nomeEmpreendimento = dados.item2.empreendimento;
  }

  if (loading) {
    return (
      <div className="ContaBancaria__Container">
        <div className="text-center py-5">
          <Spinner animation="border" variant="primary" />
          <p className="mt-2">Carregando dados bancários...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="ContaBancaria__Container">
        <Alert variant="danger" className="ContaBancaria__Error">
          {error}
        </Alert>
      </div>
    );
  }

  return (
    <div className="ContaBancaria__Container">
      <div className="lotes-header py-3 mb-3">
        <div className="d-flex align-items-center justify-content-between px-3">
          <h4 className="lotes-header__title mb-0">
            Conta Bancaria - {nomeEmpreendimento}
          </h4>
        </div>
      </div>

      {!temAlgumCard ? (
        <div className="ContaBancaria__Empty">
          <p>Não há contas bancárias configuradas para o empreendimento.</p>
        </div>
      ) : (
        <>
          {/* Card Imobiliária (item2) - aparece primeiro conforme imagem */}
          {renderCard(dados && dados.item2, 'imobiliaria')}

          {/* Card Empreendimento (item1) - aparece segundo conforme imagem */}
          {renderCard(dados && dados.item1, 'empreendimento')}

          {/* Aviso de depósito */}
          {renderAviso()}
        </>
      )}
    </div>
  );
};

const EmpreendimentosContaBancaria = () => {
  const location = useLocation();
  const { familia } = useParams();

  var searchParams = new URLSearchParams(location.search || '');
  var familiaQuery = searchParams.get('Familia');
  var familiaCodigo =
    (familia && String(familia).trim()) ||
    (familiaQuery && String(familiaQuery).trim()) ||
    '';

  return <ContaBancariaContent familiaCodigo={familiaCodigo} />;
};

export const ContaBancariaModal = ({ show, onHide, codigoFamilia }) => {
  return (
    <Modal show={show} onHide={onHide} centered size="lg" scrollable>
      <Modal.Header closeButton style={{ backgroundColor: '#0747a6' }}>
        <Modal.Title style={{ color: '#FFFFFF' }}>
          Contas Bancárias
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: 0 }}>
        {show && (
          <ContaBancariaContent
            familiaCodigo={codigoFamilia ? String(codigoFamilia) : ''}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EmpreendimentosContaBancaria;
